'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _userUtil = require('../../../../userUtil');

var _stringUtil = require('../../../../../../common/utils/stringUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIST_LIMIT = 3;

var PlanIndividualDetail = function PlanIndividualDetail(_ref) {
    var isSubscriptionAdmin = _ref.isSubscriptionAdmin;
    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'div',
            { className: 'detail' },
            _react2.default.createElement(
                'p',
                { className: 'section-title' },
                'You are on an individual plan'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'action' },
            isSubscriptionAdmin ? _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/account/team' },
                    'Add team members'
                )
            ) : null
        )
    );
};

var TeamMemberUser = function TeamMemberUser(_ref2) {
    var user = _ref2.user,
        subscription = _ref2.subscription;

    if (!user) return null;

    return _react2.default.createElement(
        'span',
        null,
        (0, _userUtil.getDisplayName)(user),
        (0, _userUtil.isUserSubscriptionAdmin)(user, subscription) ? _react2.default.createElement(
            'strong',
            null,
            ' (admin)'
        ) : null
    );
};

TeamMemberUser.propTypes = {
    user: _propTypes2.default.object,
    subscription: _propTypes2.default.object
};

var PlanTeamDetail = function PlanTeamDetail(_ref3) {
    var subscriptionTeam = _ref3.subscriptionTeam,
        subscription = _ref3.subscription,
        isSubscriptionAdmin = _ref3.isSubscriptionAdmin;

    var teamSize = subscriptionTeam.size;

    var teamList = subscriptionTeam.sort(function (a, b) {
        if ((0, _userUtil.isUserSubscriptionAdmin)(a, subscription)) return -1;
        if ((0, _userUtil.isUserSubscriptionAdmin)(b, subscription)) return 1;

        var nameA = (0, _userUtil.getDisplayName)(a);
        var nameB = (0, _userUtil.getDisplayName)(b);
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return 0;
    }).slice(0, LIST_LIMIT);

    var remainderSize = subscriptionTeam.size - LIST_LIMIT;

    return _react2.default.createElement(
        'section',
        { className: 'wide' },
        _react2.default.createElement(
            'div',
            { className: 'detail' },
            _react2.default.createElement(
                'p',
                { className: 'section-title' },
                'Your team has ',
                teamSize,
                ' ',
                (0, _stringUtil.pluralise)('member', teamSize)
            ),
            _react2.default.createElement(
                'p',
                { className: 'usage' },
                teamList.map(function (user, i, list) {
                    return _react2.default.createElement(
                        'span',
                        { key: i },
                        _react2.default.createElement(TeamMemberUser, { user: user, subscription: subscription }),
                        (0, _stringUtil.listSeparator)(i, list.size)
                    );
                }),
                remainderSize > 0 ? _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    '+ ',
                    remainderSize,
                    ' more...'
                ) : null
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'action' },
            isSubscriptionAdmin ? _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/account/team' },
                    'Manage team'
                )
            ) : null
        )
    );
};

var PlanTeamDetailSection = function PlanTeamDetailSection(props) {
    var subscriptionTeam = props.subscriptionTeam;


    if (!subscriptionTeam) return null;
    var teamSize = subscriptionTeam.size;

    return teamSize > 1 ? _react2.default.createElement(PlanTeamDetail, props) : _react2.default.createElement(PlanIndividualDetail, props);
};

PlanIndividualDetail.propTypes = PlanTeamDetail.propTypes = PlanTeamDetailSection.propTypes = {
    subscription: _propTypes2.default.object,
    subscriptionTeam: _propTypes2.default.object,
    isSubscriptionAdmin: _propTypes2.default.bool
};

exports.default = PlanTeamDetailSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanTeamDetailSection.js
// module id = 2073
// module chunks = 0